<!-- 开卡管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>状态</span>
          <el-select
            v-model="queryInfo.status"
            filterable
            placeholder="请选择状态"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="searchItem">
          <!-- <el-button type="primary" size="small" @click="queryTable('search')"
          >搜索</el-button
        >
        <el-button type="warning" size="small" @click="resetQuery"
          >重置</el-button
        > -->
          <MyButton
            value="搜索"
            size="medium"
            icon="el-icon-search"
            type="1"
            @click="queryTable('search')"
          ></MyButton>
          <MyButton
            value="重置"
            size="medium"
            type="2"
            @click="resetQuery"
          ></MyButton>
        </div>
      </div>

      <div>
        <div class="table">
          <TableComponents :columns="columns" :tableData="tableList">
            <template slot="operation" slot-scope="{ row }">
              <el-button
                v-if="row.status == 2"
                type="warning"
                size="mini"
                @click="viewDetail(row)"
                >下载</el-button
              >
            </template>
          </TableComponents>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.page"
              :page-sizes="[10, 30, 50, 80]"
              :page-size="queryInfo.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="queryInfo.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "cardExportLog", //数据导出中心
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        status: -1,
      },
      columns: [
        //列数据
        { label: "id", prop: "id" },
        { label: "状态", prop: "status_name" },
        { label: "文件名", prop: "export_name" },
        { label: "创建时间", prop: "created_at" },
        { label: "创建人", prop: "tob_admin_name" },
        { label: "类型名称", prop: "type_name" },
        { label: "操作", prop: "operation" },
      ],
      tableList: [],

      statusOptions: [
        //开卡状态：-1全部 0创建中 1开始导出 2导出完成
        {
          value: -1,
          label: "全部",
        },
        {
          value: 0,
          label: "创建中",
        },
        {
          value: 1,
          label: "开始导出",
        },
        {
          value: 2,
          label: "导出完成",
        },
      ],

      rules: {
        //   name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryTable();
  },
  methods: {
    viewDetail(row) {
      console.log("viewDetail", row);
      window.open(row.export_name, "_blank");
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await commonApi.getTobStudyCardExportLog(this.queryInfo);
      if (res.code == 200) {
        this.queryInfo.total = res.data.list.total;
        this.tableList = res.data.list.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        status: -1,
      };
      this.queryTable();
    },
    // 分页
    handleSizeChange(e) {
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 10px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        // padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin-bottom: 10px;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }

  /deep/.tagDetail {
    padding: 10px;
    border: 1px solid #ddd;
    margin: 10px 0;
  }

  /deep/.el-input-number {
    width: 250px;
  }
  /deep/.goodName {
  }
}
</style>
